import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Laverage(props) {
  return (
    <div
      className="laverage_section laverage_ecommerce_app p-100"
      style={{ backgroundColor: "#FCFCFC" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Key Focus Domains in Crafting E-commerce Applications</h2>
            <p>
              Excelling in E-commerce mobile app development, we specialize in
              tailoring applications to seamlessly meet the unique requirements
              of businesses and users alike.
            </p>
            <p>
              Our focus encompasses key facets to ensure a bespoke and
              harmonious experience in every E-commerce app we craft. Here are
              the key areas we focus most on in our e-commerce app development:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h6>UI/UX Centric Ecommerce App Design</h6>
                <p>
                  Our E-commerce app designs boast meticulously crafted
                  interfaces, ensuring a seamless and interactive user
                  experience. We prioritize intuitive design elements to enhance
                  usability and overall functionality.
                </p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h6>Custom Search Features</h6>
                <p>
                  The central, user-centric feature in all e-commerce apps, our
                  custom search features make it easier for users to navigate to
                  and find their favorite products and categories.
                </p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h6>Streamlined Checkout & Payment Modes</h6>
                <p>
                  Tackling the challenge of cart abandonment rates prevalent in
                  E-commerce apps, we ensure a streamlined solution. Our
                  commitment lies in providing a simple and intuitive checkout
                  process for consumers, eliminating hurdles, and enhancing the
                  overall shopping experience in your app.
                </p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h6>Bug Free & Optimization for Fast Speeds</h6>
                <p>
                  We prioritize the optimization of speed in our E-commerce
                  apps, delivering a supercharged, frustration-free experience
                  for users. Our specific focus on performance ensures swift and
                  seamless interactions, enhancing overall satisfaction in the
                  app.
                </p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h6>Integration For Updates & Alerts</h6>
                <p>
                  Instant awareness of offers and discounts is paramount for
                  consumers. To address this, our apps feature seamless
                  integration of email updates and alerts, ensuring users stay
                  promptly informed about the latest promotions and discounts.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
